<script setup lang="ts">
defineProps<{ title?: string, products?: Packet[] }>()
</script>

<template>
  <UContainer class="py-xl">
    <h1
      v-if="title"
      class="mb-m text-center font-headline text-3xl text-white"
      v-text="title"
    />
    <HomeProductCards
      v-if="products?.length"
      :products="products"
      class="mb-l"
    />
    <PacketRelatedCta
      text="Se alle våre bøker og digitale læremidler"
      link-label="Gå til produktkatalogen"
      :link-to="{ name: 'products' }"
    />
  </UContainer>
</template>
